module.exports = __webpack_public_path__ + "static/media/icn_upi_apps.7f1a8acf.svg";